import React, { useEffect } from 'react';
import Button from './Button';
import LayerOverlay from './LayerOverlay';
import './ConfirmDialog.css';

/* Confirmación bloqueante (F2, brief §11: modal SOLO para acciones cortas y
   bloqueantes). Toda acción destructiva pasa por acá (ESTANDAR §6: destructivo
   SIEMPRE con confirmación). Portal (ESTANDAR §13.3). */
export default function ConfirmDialog({
  open = false,
  title = '¿Confirmar?',
  children = null,          // el mensaje — decir las CONSECUENCIAS, no solo "¿seguro?"
  confirmLabel = 'Confirmar',
  cancelLabel = 'Cancelar',
  destructive = true,
  loading = false,
  onConfirm,
  onCancel,
}) {
  useEffect(() => {
    if (!open) return undefined;
    const handler = (e) => { if (e.key === 'Escape' && !loading) onCancel?.(); };
    window.addEventListener('keydown', handler);
    return () => window.removeEventListener('keydown', handler);
  }, [open, loading, onCancel]);

  return (
    <LayerOverlay open={open} className="ui-confirm-overlay" onBackdrop={() => { if (!loading) onCancel?.(); }}>
      <div className="ui-confirm" role="alertdialog" aria-modal="true" aria-label={title}>
        <h3 className="ui-confirm-title">{title}</h3>
        {children && <div className="ui-confirm-body">{children}</div>}
        <div className="ui-confirm-actions">
          <Button variant="secondary" onClick={onCancel} disabled={loading}>{cancelLabel}</Button>
          <Button
            variant={destructive ? 'destructive' : 'primary'}
            onClick={onConfirm}
            loading={loading}
            autoFocus
          >{confirmLabel}</Button>
        </div>
      </div>
    </LayerOverlay>
  );
}
